module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"extranet":"Connexion distributeur","link_extranet":"http://member.cmimulching.com/membreaccueil"},"en":{"extranet":"Dealer login","link_extranet":"http://member.cmimulching.com/MemberHome"}}')
  delete Component.options._Ctor
}
